import { render } from "./NoWzCaseFound.vue?vue&type=template&id=66191fa4"
import script from "./NoWzCaseFound.vue?vue&type=script&lang=js"
export * from "./NoWzCaseFound.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__